import { Label } from 'components/atoms/index';
import Switch from 'react-switch';
import './SwitchInput.scss';

interface ISwitchAtomProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  [key: string]: any;
  label?: string;
}

const SwitchInput: React.FC<ISwitchAtomProps> = ({
  checked,
  label,
  onChange,
  ...props
}) => {
  return (
    <div className='switch-wrapper'>
      <Switch
        checked={checked}
        onChange={onChange}
        uncheckedIcon={false}
        checkedIcon={false}
        height={20}
        width={37}
        {...props}
      />
      {label && <Label color={'transparent'}>{label}</Label>}
    </div>
  );
};

export default SwitchInput;
